module.exports = __webpack_public_path__ + "src/assets/img/cushion_01_de.24db9178.png";